module.exports = __webpack_public_path__ + "img/UBS-logo.950b430b.png";